// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';
import { media } from '../../../../helpers';

const PromotionImageContainer = styled<any, Theme>('div')`
  background: url(${props => props.background}) center center no-repeat;
  background-size: cover;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  align-items: center;
  display: flex;
  flex-shrink: 0;
  justify-items: center;
  min-height: 6.25rem;
  min-width: 6.25rem;
  width: 100%;

  ${media.lg(css`
    img {
      max-width: 16rem;
      max-height: 12rem;
    }
  `)}

  ${media.xl(css`
    border-bottom-left-radius: 6px;
    border-top-right-radius: 0;
    width: 50%;
  `)}

  > div {
    height: auto;
    width: 100%;
  }
`;

export default PromotionImageContainer;
